export default "__VITE_ASSET__CBn87DeK__"